var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5158 0H24L16.752 7.08177C15.4854 8.31074 13.7784 9 12 9C10.2216 9 8.5152 8.31074 7.248 7.08177L0 0H3.4842L8.9916 5.36985C9.7944 6.14956 10.8756 6.587 12.003 6.587C13.1304 6.587 14.2116 6.14956 15.0144 5.36985L20.5158 0Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0144 14.6301C14.2116 13.8504 13.1304 13.413 12.003 13.413C10.8756 13.413 9.7944 13.8504 8.9916 14.6301L3.4842 20H0L7.248 12.9182C8.5146 11.6893 10.2216 11 12 11C13.7784 11 15.4848 11.6893 16.752 12.9182L24 20H20.5158L15.0144 14.6301Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.8df5f76f54ec650dfa40565187b50a8e.svg";
export { ForwardRef as ReactComponent };